export const MIN_AGE_YEARS = 18;

export const MAX_AGE_YEARS = 99;

export type DateOfBirthError = "format" | "invalid" | "future" | "tooYoung" | "tooOld";

const DOB_PATTERN = /^(\d{2})\/(\d{2})\/(\d{4})$/;

function yearsBefore(now: Date, years: number): Date {
  const year = now.getFullYear() - years;
  const lastDayOfMonth = new Date(year, now.getMonth() + 1, 0).getDate();

  return new Date(year, now.getMonth(), Math.min(now.getDate(), lastDayOfMonth));
}

export function dateOfBirthError(value: string, now: Date = new Date()): DateOfBirthError | null {
  const match = DOB_PATTERN.exec(value);

  if (!match) {
    return "format";
  }

  const month = Number(match[1]);
  const day = Number(match[2]);
  const year = Number(match[3]);

  const dateOfBirth = new Date(year, month - 1, day);

  const isRealDate =
    dateOfBirth.getFullYear() === year &&
    dateOfBirth.getMonth() === month - 1 &&
    dateOfBirth.getDate() === day;

  if (!isRealDate) {
    return "invalid";
  }

  if (year > now.getFullYear()) {
    return "future";
  }

  if (dateOfBirth > yearsBefore(now, MIN_AGE_YEARS)) {
    return "tooYoung";
  }

  if (dateOfBirth <= yearsBefore(now, MAX_AGE_YEARS)) {
    return "tooOld";
  }

  return null;
}

export function isCompleteDateOfBirth(value: string): boolean {
  return DOB_PATTERN.test(value);
}
